import axios from "axios";
import { getAuthToken } from "../helpers/local_storage_helpers";
import {
    fpoAssetsUrl,
    fpoAssetDetailUrl,
    fpoAssetSummaryUrl,
    fpoAssetLookupsUrl,
} from "../constants/apis";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

// ── Asset Register ─────────────────────────────────────────────

/** GET /fpo/assets/?page=&search=&category=&condition=&allocated_type=&warehouse=&is_active= */
export const getAssets = async (params = {}) => {
    return axios.get(fpoAssetsUrl, { ...authHeaders(), params });
};

/** GET /fpo/assets/<id>/ */
export const getAsset = async (id) => {
    return axios.get(fpoAssetDetailUrl(id), authHeaders());
};

/** POST /fpo/assets/ — multipart/form-data for invoice_file / image */
export const createAsset = async (data) => {
    return axios.post(fpoAssetsUrl, data, {
        headers: {
            Authorization: `Token ${getAuthToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });
};

/** PATCH /fpo/assets/<id>/ */
export const updateAsset = async (id, data) => {
    return axios.patch(fpoAssetDetailUrl(id), data, {
        headers: {
            Authorization: `Token ${getAuthToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });
};

/** DELETE /fpo/assets/<id>/ — soft-delete (sets is_active=False) */
export const deleteAsset = async (id) => {
    return axios.delete(fpoAssetDetailUrl(id), authHeaders());
};

/** GET /fpo/assets/summary/ */
export const getAssetSummary = async () => {
    return axios.get(fpoAssetSummaryUrl, authHeaders());
};

/** GET /fpo/assets/lookups/ — staff, members, warehouses, category/condition choices */
export const getAssetLookups = async () => {
    return axios.get(fpoAssetLookupsUrl, authHeaders());
};
